import { render, staticRenderFns } from "./RegionPage.vue?vue&type=template&id=7ff05a04"
import script from "./RegionPage.vue?vue&type=script&lang=js"
export * from "./RegionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports